import { Result, Button } from 'antd';

export function Error404(){
return(
<Result
    status="404"
    title="404"
    subTitle="Sorry, something went wrong."
    extra={<Button type="primary">Back Home</Button>}
  />
)
}